export default "__VITE_ASSET__voG_vG7C__"